var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(_vm.isDemo)?_c('md-button',{staticClass:"md-dense md-primary",attrs:{"disabled":!_vm.isLoginEnabled},on:{"click":_vm.loginAndCreateAdminAccount}},[_vm._v("Create Admin demo account ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }